import React from "react";
import UserAdmin from "./User&Admin/userDanAdmin";

const Beranda = () => {
  return (
    <div className="p-3">
      <div className="flex justify-start font-bold text-2xl">Dashboard</div>
      <div className="mt-3">
        <UserAdmin />
      </div>
    </div>
  );
};

export default Beranda;
